'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordFromPinService = function () {
  function ResetPasswordFromPinService($http) {
    'ngInject';

    _classCallCheck(this, ResetPasswordFromPinService);

    this.$http = $http;
  }

  _createClass(ResetPasswordFromPinService, [{
    key: 'changePasswordFromPin',
    value: function changePasswordFromPin(credentials) {
      return this.$http.post('/api/account/password_reset_from_pin', credentials);
    }
  }]);

  return ResetPasswordFromPinService;
}();

exports.default = ResetPasswordFromPinService;


// WEBPACK FOOTER //
// ./components/auth/reset-password-frompin/reset-password-frompin.service.js